{
  "account-page-container": {
    "text": {
      "account": "Mon compte",
      "logout": "Déconnexion",
      "my-appointments": "Mes rendez-vous",
      "my-profile": "Mon profil",
      "my-salons": "Mes salons"
    }
  }
}
